import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AdvancedTestingTopicsModule = () => (
  <QPhototModuleSubtopic
    title="Regression Testing, Mutation Testing, Object Oriented Testing, Web and Mobile App Testing, DevOps, Cloud and Big Data Testing"
    videos={[
      "https://www.youtube.com/embed/jUg_ml1EvV8",
      "https://www.youtube.com/embed/AIOh1zcZmh8",
      "https://www.youtube.com/embed/ws1fwSlpWCk",
      "https://www.youtube.com/embed/xAm6Iadj-uY"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "You are assigned with testing a banking application's transfer functionality. The system allows users to transfer funds between their own accounts and to other accounts within the same bank. Perform a black-box testing method to ensure the transfer functionality is working correctly in the bank."
      },
      {
        text:
          "Imagine you're a Quality Assurance (QA) tester for a new e-commerce clothing store website called \"Trendy Threads.\" This website allows users to browse clothing items, add them to a shopping cart, checkout using various payment methods, and track their orders. How would you design and execute a comprehensive test plan to ensure the functionality, usability, and security of the Trendy Threads website?"
      }
    ]}
    exampleVideos={[]}
  />
);

export default AdvancedTestingTopicsModule;
